import React from "react"
import { Navbar } from "../components/Navbar"
import { Footer } from "../components/Footer"
import { NavBarMobile } from "../components/NavBarMobile"
import { useAppSelector } from "../store/hooks"
import { Outlet, useLocation } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"

interface MainLayoutProps extends React.PropsWithChildren {
    test: string
}

export const MainLayout: React.FC<MainLayoutProps> = (props) => {

    const displayType = useAppSelector((state) => state.display.type);

    const location = useLocation();
    const hideFooterRoutes = ['/chats', '/rentals-chats'];
    const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

    return (
        <div>
            <div className="hidden lg:block">
                <Navbar></Navbar>
            </div>
            <div className="lg:hidden">
                <NavBarMobile />
            </div>

            <div className="w-full flex justify-center min-h-[80vh] px-2 lg:px-4">
                <div className="max-w-[1500px] w-full">
                    <Outlet />
                </div>
            </div>
            {!shouldHideFooter ? <Footer /> : <></>}

        </div>
    )
}